import { Col, Form, Input, Row, Select } from 'antd';
import React, { useState } from 'react';

import { Icon, PhoneInput } from '@common/components';
import { PasswordValidationFeedback } from '@identity/components';
import { passwordValidator } from '@identity/services';
import { TimeZonesQueryResponse } from '@institutions/graphql';

export const SupplierSignupPageUserProfileForm = ({
  formSubmitting,
  timeZonesQueryData,
}: {
  formSubmitting: boolean;
  timeZonesQueryData: TimeZonesQueryResponse | undefined;
}) => {
  const [newPassword, setNewPassword] = useState('');
  const passwordName = 'password';

  return (
    <>
      <Form.Item
        style={{ width: '100%' }}
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            message: 'Please input the email',
          },
          {
            type: 'email',
            message: 'Please enter a valid email address',
          },
        ]}
      >
        <Input size="large" disabled />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[
              {
                required: true,
                message: 'Please input the first name',
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[
              {
                required: true,
                message: 'Please input the last name',
              },
            ]}
          >
            <Input size="large" disabled={formSubmitting} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        style={{ width: '100%' }}
        label="Phone Number"
        name="phone"
        rules={[
          {
            required: true,
            message: 'Please enter a phone number',
          },
          {
            required: true,
            pattern: /^(\d{3}-){2}\d{4}$/,
            message: 'Phone numbers must be in xxx-xxx-xxxx format',
          },
        ]}
      >
        <PhoneInput size="large" />
      </Form.Item>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: `Please create your ${passwordName}.`,
              },
              {
                validator: (_, value) => {
                  if (passwordValidator(value)) {
                    return Promise.reject('Password must include:');
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              size="large"
              type="password"
              prefix={<Icon icon="unlock" kind="light" />}
              placeholder={`create ${passwordName}`}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="off"
              disabled={formSubmitting}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Confirm Password"
            name="passwordConfirmation"
            rules={[
              {
                required: true,
                message: `Please confirm your ${passwordName}.`,
              },
              {
                validator: (_, value) => {
                  if (value && value.length > 0 && newPassword !== value) {
                    return Promise.reject(
                      'Password does not match what you entered initially.'
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              prefix={<Icon icon="lock" kind="light" />}
              type="password"
              placeholder={`confirm ${passwordName}`}
              size="large"
              autoComplete="off"
              disabled={formSubmitting}
            />
          </Form.Item>
        </Col>
      </Row>

      <PasswordValidationFeedback password={newPassword} />

      <Form.Item
        style={{ width: '100%' }}
        name="timeZone"
        label="Timezone"
        rules={[{ required: true, message: "Value can't be blank" }]}
      >
        <Select size="large" disabled={formSubmitting}>
          {timeZonesQueryData?.timeZones.map(
            (timeZone: { text: string; value: string }) => (
              <Select.Option key={timeZone.value} value={timeZone.value}>
                {timeZone.text}
              </Select.Option>
            )
          )}
        </Select>
      </Form.Item>
    </>
  );
};
